/* ==========================================================================
   PHENORA · Cookie-Consent-Banner (Usercentrics CMP v2)
   --------------------------------------------------------------------------
   EBENE 1 (Start):   Ich akzeptiere alle · Nur essenzielle Cookies akzeptieren
                      · Individuelle Datenschutz-Präferenzen
   EBENE 2 (Details): Speichern · Alle akzeptieren · Nur essenzielle Cookies
                      akzeptieren – plus "Zurück" oben links
   Anrede durchgehend Du. Phenora-Farbwelt.

   MOBIL – überarbeitet am 14.08.2026 nach Prüfung auf echtem Gerät:
   - Schrift nicht mehr halbfett, sondern normal. Nur "Alles akzeptieren"
     bleibt etwas kräftiger. Halbfett wirkte auf dem iPhone klobig.
   - Deutlich mehr Luft zwischen den Buttons (14 statt 8 px) und Abstand
     zwischen Textblock und Buttonblock. Vorher klebte alles aneinander.
   - Schrift von 14.5 auf 15 px, Zeilenabstand im Fließtext erhöht.
   - Der Kasten darf 90 % der Bildschirmhöhe nutzen (Usercentrics-Standard
     wären 80 %), damit die Kategorienliste auf kleinen Geräten Platz hat.
   - Umbruchpunkt 768 px, identisch mit dem von Usercentrics.

   WICHTIG – so ist das absichtlich gebaut:
   Texte werden nur ersetzt, wenn der Originaltext EXAKT so dasteht wie am
   14.08.2026. Ändert die IT-Recht Kanzlei einen Rechtstext, greift die
   Ersetzung nicht mehr und der NEUE Originaltext wird angezeigt.

   Die Consent-Logik wird NICHT angefasst. Der "Zurück"-Button ruft
   ausschließlich die offizielle Usercentrics-Funktion showFirstLayer() auf.

   Rechtliche Konstruktion – nicht ohne Rücksprache ändern:
   "Nur essenzielle Cookies akzeptieren" hat auf beiden Ebenen exakt dieselbe
   Größe, Höhe, Schrift und Form wie der Akzeptieren-Button – nur eine andere
   Füllfarbe. Gleichwertigkeit gemäß OLG Köln, 19.01.2024, Az. 6 U 80/23.
   ========================================================================== */

(function () {
  'use strict';

  var STYLE_ID = 'phenora-consent-style';
  var BACK_ID = 'phenora-uc-back';
  var BOX = '[data-testid="uc-buttons-container"]';
  var PANEL = '[data-testid="uc-default-banner"],[data-testid="uc-default-settings"],[data-testid="uc-default-wall"]';
  var SANS = '-apple-system,BlinkMacSystemFont,"Segoe UI",Helvetica,Arial,sans-serif';

  var TEXTE = {
    'ABLEHNEN': 'Nur essenzielle Cookies akzeptieren',
    'MEHR': 'Individuelle Datenschutz-Präferenzen',
    'SPEICHERN': 'Speichern',

    'WIR SCHÜTZEN IHRE PRIVATSPHÄRE': 'Wir schützen deine Privatsphäre',
    'PRIVATSPHÄRE-EINSTELLUNGEN': 'Deine Privatsphäre-Einstellungen',

    'Auf dieser Website kommen Cookies und ähnliche Technologien zum Einsatz, die der Leistungsoptimierung, der Personalisierung von Anzeigen sowie weiteren Marketing- und/oder Analysezwecken dienen können. Über die unten stehenden Funktionen haben Sie die Möglichkeit, Ihr Einwilligungsverhalten zu steuern, also Einwilligungen zu erteilen, zu verweigern oder zu widerrufen.':
      'Auf dieser Website kommen Cookies und ähnliche Technologien zum Einsatz, die der Leistungsoptimierung, der Personalisierung von Anzeigen sowie weiteren Marketing- und/oder Analysezwecken dienen können. Über die unten stehenden Funktionen hast du die Möglichkeit, dein Einwilligungsverhalten zu steuern, also Einwilligungen zu erteilen, zu verweigern oder zu widerrufen.',

    'Cookies sind kleine Textdateien, die von Webseiten verwendet werden, um die Benutzererfahrung effizienter zu gestalten. Laut Gesetz können wir Cookies auf Ihrem Gerät speichern, wenn diese für den Betrieb dieser Seite unbedingt notwendig sind. Für alle anderen Cookie-Typen benötigen wir Ihre Erlaubnis. Diese Seite verwendet unterschiedliche Cookie-Typen. Einige Cookies werden von Drittparteien platziert, die auf unseren Seiten erscheinen.':
      'Cookies sind kleine Textdateien, die von Webseiten verwendet werden, um die Benutzererfahrung effizienter zu gestalten. Laut Gesetz können wir Cookies auf deinem Gerät speichern, wenn diese für den Betrieb dieser Seite unbedingt notwendig sind. Für alle anderen Cookie-Typen benötigen wir deine Erlaubnis. Diese Seite verwendet unterschiedliche Cookie-Typen. Einige Cookies werden von Drittparteien platziert, die auf unseren Seiten erscheinen.',

    'Diese Technologien werden von Werbetreibenden verwendet, um Anzeigen zu schalten, die für Ihre Interessen relevant sind.':
      'Diese Technologien werden von Werbetreibenden verwendet, um Anzeigen zu schalten, die für deine Interessen relevant sind.'
  };

  var CSS = [
    BOX + '{',
    '  display:flex !important; flex-direction:column !important;',
    '  align-items:stretch !important; justify-content:flex-start !important;',
    '  flex-wrap:nowrap !important; gap:11px !important; width:100% !important;',
    '}',
    BOX + ' > *{',
    '  width:100% !important; max-width:100% !important; min-width:0 !important;',
    '  margin:0 !important; flex:0 0 auto !important;',
    '}',

    /* Ebene 1 */
    BOX + ' > [data-testid="uc-accept-all-button"]{order:1 !important;}',
    BOX + ' > [data-testid="uc-deny-all-button"]{order:2 !important;}',
    BOX + ' > [data-testid="uc-more-button"]{order:4 !important;}',

    /* Ebene 2 – erkennbar am Speichern-Button */
    BOX + ':has([data-testid="uc-save-button"]) > [data-testid="uc-save-button"]{order:1 !important;}',
    BOX + ':has([data-testid="uc-save-button"]) > [data-testid="uc-accept-all-button"]{order:2 !important;}',
    BOX + ':has([data-testid="uc-save-button"]) > [data-testid="uc-deny-all-button"]{order:3 !important;}',

    /* gemeinsame Geometrie – Akzeptieren und Ablehnen exakt gleich */
    '[data-testid="uc-accept-all-button"],',
    '[data-testid="uc-deny-all-button"],',
    '[data-testid="uc-save-button"],',
    '[data-testid="uc-more-button"]{',
    '  display:flex !important; align-items:center !important; justify-content:center !important;',
    '  width:100% !important; min-height:54px !important; height:auto !important;',
    '  padding:15px 20px !important; margin:0 !important;',
    '  border-radius:4px !important; border:1px solid transparent !important; box-shadow:none !important;',
    '  font-family:' + SANS + ' !important;',
    '  font-size:15px !important; font-weight:400 !important; letter-spacing:0.01em !important;',
    '  text-transform:none !important; line-height:1.35 !important; text-align:center !important;',
    '  cursor:pointer !important;',
    '  transition:background-color .3s ease, border-color .3s ease, color .3s ease, transform .4s cubic-bezier(.2,.8,.2,1) !important;',
    '}',
    '[data-testid="uc-accept-all-button"]{background:#7A8B3D !important; color:#F0EFEA !important; border-color:#7A8B3D !important; font-weight:500 !important;}',
    '[data-testid="uc-accept-all-button"]:hover{background:#98A85A !important; border-color:#98A85A !important; transform:translateY(-1px) !important;}',
    '[data-testid="uc-deny-all-button"]{background:#F0EFEA !important; color:#15191F !important; border-color:#F0EFEA !important;}',
    '[data-testid="uc-deny-all-button"]:hover{background:#FFFFFF !important; border-color:#FFFFFF !important; transform:translateY(-1px) !important;}',
    '[data-testid="uc-save-button"]{background:transparent !important; color:rgba(240,239,234,.94) !important; border-color:rgba(240,239,234,.40) !important;}',
    '[data-testid="uc-save-button"]:hover{background:rgba(240,239,234,.07) !important; border-color:rgba(240,239,234,.80) !important;}',

    /* Individuelle Datenschutz-Praeferenzen – dezent, nur WENN Ablehnen daneben steht */
    BOX + ':has([data-testid="uc-deny-all-button"]) [data-testid="uc-more-button"],',
    '.phenora-uc--deny-present [data-testid="uc-more-button"]{',
    '  background:transparent !important; color:#98A85A !important; border-color:transparent !important;',
    '  min-height:48px !important; font-size:14px !important; font-weight:400 !important;',
    '  text-decoration:underline !important; text-underline-offset:3px !important;',
    '}',
    BOX + ':has([data-testid="uc-deny-all-button"]) [data-testid="uc-more-button"]:hover,',
    '.phenora-uc--deny-present [data-testid="uc-more-button"]:hover{color:#F0EFEA !important;}',
    BOX + ':not(:has([data-testid="uc-deny-all-button"])) [data-testid="uc-more-button"],',
    '.phenora-uc--no-deny [data-testid="uc-more-button"]{',
    '  background:transparent !important; color:rgba(240,239,234,.94) !important; border-color:rgba(240,239,234,.40) !important;',
    '}',

    /* Zurueck-Button auf Ebene 2 */
    '#' + BACK_ID + '{',
    '  display:inline-flex !important; align-items:center !important; gap:6px !important;',
    '  background:none !important; border:0 !important; box-shadow:none !important;',
    '  padding:0 0 12px 0 !important; margin:0 !important; cursor:pointer !important;',
    '  min-height:32px !important;',
    '  font-family:' + SANS + ' !important; font-size:14px !important; font-weight:400 !important;',
    '  letter-spacing:0.01em !important; line-height:1.2 !important;',
    '  color:#98A85A !important; text-decoration:none !important; width:auto !important;',
    '  transition:color .25s ease !important;',
    '}',
    '#' + BACK_ID + ':hover{color:#F0EFEA !important; text-decoration:underline !important; text-underline-offset:3px !important;}',
    '#' + BACK_ID + ':focus-visible{outline:2px solid #98A85A !important; outline-offset:3px !important;}',

    /* Ueberschrift und Fliesstext */
    '[data-testid="uc-heading-title"]{',
    '  font-family:"Instrument Serif",Georgia,serif !important; font-weight:400 !important;',
    '  font-size:26px !important; line-height:1.15 !important;',
    '  letter-spacing:-0.01em !important; text-transform:none !important;',
    '}',
    '[data-testid="uc-message-container"]{ line-height:1.6 !important; }',
    '[data-testid="uc-anchors"] a,[data-testid="uc-anchor-link"]{color:#98A85A !important; text-underline-offset:3px !important;}',

    /* ---------- MOBIL: gleicher Umbruchpunkt wie Usercentrics (768 px) ---------- */
    '@media (max-width:768px){',
    '  ' + PANEL + '{max-height:90vh !important;}',
    '  [data-testid="uc-footer"]{padding:14px 18px calc(18px + env(safe-area-inset-bottom, 0px)) !important;}',
    '  [data-testid="uc-header"]{padding-left:18px !important; padding-right:18px !important;}',
    '  ' + BOX + '{gap:14px !important;}',
    '  [data-testid="uc-accept-all-button"],',
    '  [data-testid="uc-deny-all-button"],',
    '  [data-testid="uc-save-button"]{min-height:54px !important; padding:15px 16px !important; font-size:15px !important;}',
    '  [data-testid="uc-more-button"]{min-height:48px !important; font-size:14px !important;}',
    '  [data-testid="uc-heading-title"]{font-size:24px !important;}',
    '  [data-testid="uc-message-container"]{font-size:13.5px !important; line-height:1.6 !important;}',
    '  #' + BACK_ID + '{font-size:13.5px !important; padding-bottom:10px !important;}',
    '}',
    /* Sehr schmale Geraete (iPhone SE 1. Gen und aehnlich) */
    '@media (max-width:340px){',
    '  ' + BOX + '{gap:11px !important;}',
    '  [data-testid="uc-accept-all-button"],',
    '  [data-testid="uc-deny-all-button"],',
    '  [data-testid="uc-save-button"]{font-size:14.5px !important; padding:14px 10px !important;}',
    '  [data-testid="uc-more-button"]{font-size:13.5px !important;}',
    '}'
  ].join('\n');

  var hat = Object.prototype.hasOwnProperty;

  function getShadow() {
    var host = document.querySelector('#usercentrics-root');
    return host && host.shadowRoot ? host.shadowRoot : null;
  }

  function istEbene2(sr) {
    return !!(sr.querySelector('[data-testid="uc-default-settings"]') ||
              sr.querySelector('[data-testid="uc-save-button"]'));
  }

  function injectStyle(sr) {
    if (sr.querySelector('#' + STYLE_ID)) return;
    var el = document.createElement('style');
    el.id = STYLE_ID;
    el.textContent = CSS;
    sr.appendChild(el);
  }

  function setzeText(el, text) {
    if (!el) return;
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var n = w.nextNode();
    if (n) { if (n.nodeValue !== text) n.nodeValue = text; }
    else if (el.textContent !== text) { el.textContent = text; }
  }

  function relabel(sr) {
    var walker = document.createTreeWalker(sr, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var p = node.parentElement;
      if (!p || p.tagName === 'STYLE' || p.tagName === 'SCRIPT') continue;
      var key = (node.nodeValue || '').trim();
      if (key && hat.call(TEXTE, key) && node.nodeValue !== TEXTE[key]) {
        node.nodeValue = TEXTE[key];
      }
    }
    setzeText(sr.querySelector('[data-testid="uc-accept-all-button"]'),
              istEbene2(sr) ? 'Alle akzeptieren' : 'Ich akzeptiere alle');

    var beschriftet = sr.querySelectorAll('[aria-label]');
    for (var i = 0; i < beschriftet.length; i++) {
      var al = beschriftet[i].getAttribute('aria-label');
      if (al && hat.call(TEXTE, al)) beschriftet[i].setAttribute('aria-label', TEXTE[al]);
    }
  }

  function zurueckButton(sr) {
    var vorhanden = sr.querySelector('#' + BACK_ID);
    if (!istEbene2(sr)) {
      if (vorhanden && vorhanden.parentNode) vorhanden.parentNode.removeChild(vorhanden);
      return;
    }
    if (vorhanden) return;
    var header = sr.querySelector('[data-testid="uc-header"]');
    if (!header) return;
    var b = document.createElement('button');
    b.id = BACK_ID;
    b.type = 'button';
    b.setAttribute('aria-label', 'Zurück zur Übersicht');
    b.textContent = '‹  Zurück';
    b.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      try { window.UC_UI.showFirstLayer(); } catch (err) {}
    });
    header.insertBefore(b, header.firstChild);
  }

  function arrange(sr) {
    var container = sr.querySelector(BOX);
    if (!container) return;
    var hasDeny = !!container.querySelector('[data-testid="uc-deny-all-button"]');
    var wanted = hasDeny ? 'phenora-uc--deny-present' : 'phenora-uc--no-deny';
    var unwanted = hasDeny ? 'phenora-uc--no-deny' : 'phenora-uc--deny-present';
    if (!container.classList.contains(wanted)) container.classList.add(wanted);
    if (container.classList.contains(unwanted)) container.classList.remove(unwanted);

    var reihenfolge = container.querySelector('[data-testid="uc-save-button"]')
      ? [['uc-save-button', '1'], ['uc-accept-all-button', '2'], ['uc-deny-all-button', '3']]
      : [['uc-accept-all-button', '1'], ['uc-deny-all-button', '2'], ['uc-more-button', '4']];

    for (var i = 0; i < reihenfolge.length; i++) {
      var btn = container.querySelector('[data-testid="' + reihenfolge[i][0] + '"]');
      if (!btn) continue;
      var child = btn;
      while (child.parentElement && child.parentElement !== container) child = child.parentElement;
      if (child.parentElement !== container) continue;
      if (child.style.order !== reihenfolge[i][1]) child.style.setProperty('order', reihenfolge[i][1], 'important');
      if (child.style.width !== '100%') child.style.setProperty('width', '100%', 'important');
    }
  }

  function apply() {
    var sr = getShadow();
    if (!sr) return;
    try { injectStyle(sr); } catch (e) {}
    try { arrange(sr); } catch (e) {}
    try { relabel(sr); } catch (e) {}
    try { zurueckButton(sr); } catch (e) {}
  }

  var geplant = false;
  function applyBald() {
    if (geplant) return;
    geplant = true;
    window.setTimeout(function () { geplant = false; apply(); }, 0);
  }

  var beobachtet = false;
  function beobachten() {
    if (beobachtet) return;
    var sr = getShadow();
    if (!sr) return;
    try {
      new MutationObserver(applyBald).observe(sr, { childList: true, subtree: true, characterData: true });
      beobachtet = true;
    } catch (e) {}
  }

  window.setInterval(function () {
    var sr = getShadow();
    if (!sr) return;
    beobachten();
    apply();
  }, 500);

  apply();
  beobachten();
  window.addEventListener('ucEvents', applyBald);
  document.addEventListener('visibilitychange', applyBald);
  window.addEventListener('orientationchange', applyBald);
})();
